import ReportCommentServices from "@/http/api/report/ReportCommentServices";
import {useMutation} from "@tanstack/react-query";

export default class ReportQueryHooks extends ReportCommentServices{

    useAcceptReport = () => {
        return useMutation({
            mutationFn : this.acceptReport,
            mutationKey : ["acceptReport"],
        })
    }

}